import React, { useEffect, useState } from 'react';
import { Box, Paper } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import type { EngagementTimeRange } from '../../utils/engagementAnalytics';
import EngagementPerformanceTrends, {
  type EngagementPerformanceTrendsProps,
} from './EngagementPerformanceTrends';
import EngagementMetricsOverview from './EngagementMetricsOverview';

export interface EngagementInsightsContainerProps extends EngagementPerformanceTrendsProps {}

export const metricsSectionWrapperSx: SxProps<Theme> = {
  mt: { xs: 2, md: 3 },
  borderTop: { md: '1px solid' },
  borderColor: 'divider',
  pt: { md: 2 },
};

export const metricsOverviewLayoutSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  '& .metric-cards': {
    display: 'grid',
    gridTemplateColumns: {
      xs: '1fr',
      sm: 'repeat(2, 1fr)',
      md: 'repeat(4, 1fr)',
    },
    gap: { xs: 2, md: 3 },
  },
};

export const EngagementInsightsContainer: React.FC<EngagementInsightsContainerProps> = ({
  timeRange,
  onTimeRangeChange,
  refreshToken,
  onRefresh,
}) => {
  const [localRefreshToken, setLocalRefreshToken] = useState(0);

  useEffect(() => {
    if (!refreshToken) {
      return;
    }

    setLocalRefreshToken((prev) => prev + 1);
  }, [refreshToken]);

  const handleLocalRefresh = () => {
    setLocalRefreshToken((prev) => prev + 1);
    onRefresh?.();
  };

  return (
    <Paper data-testid="engagement-insights-container" sx={{ p: { xs: 2, md: 3 } }}>
      <EngagementPerformanceTrends
        timeRange={timeRange}
        onTimeRangeChange={onTimeRangeChange}
        refreshToken={localRefreshToken}
        onRefresh={handleLocalRefresh}
      />
      <Box data-testid="engagement-metrics-section" sx={metricsSectionWrapperSx}>
        <EngagementMetricsOverview
          timeRange={timeRange}
          refreshToken={localRefreshToken}
          sx={metricsOverviewLayoutSx}
        />
      </Box>
    </Paper>
  );
};

export default EngagementInsightsContainer;
